import { render } from "./ClientForm.vue?vue&type=template&id=789f49bd&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=js"
export * from "./ClientForm.vue?vue&type=script&lang=js"

import "./ClientForm.vue?vue&type=style&index=0&id=789f49bd&scoped=true&lang=scss"
import "../assets/css/client.css?vue&type=style&index=1&id=789f49bd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789f49bd"]])

export default __exports__